var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 25,
    viewBox: "0 0 20 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.21274 8.11451V6.3515C3.26473 4.12154 4.56948 2.08143 6.64814 0.980046C8.72674 -0.121014 11.2729 -0.121014 13.3515 0.980046C15.4301 2.08132 16.7352 4.12144 16.7871 6.3515V8.11451C17.6392 8.11451 18.4563 8.43029 19.059 8.99264C19.6614 9.55478 20 10.3175 20 11.1126V21.1563V21.1561C20 21.9514 19.6614 22.714 19.059 23.2761C18.4563 23.8385 17.6392 24.1543 16.7871 24.1543H3.21285C2.36076 24.1543 1.54343 23.8385 0.941021 23.2761C0.338383 22.714 0 21.9515 0 21.1561V11.1124C0 10.3173 0.338406 9.55457 0.941021 8.99243C1.54343 8.43006 2.36076 8.1143 3.21285 8.1143L3.21274 8.11451ZM8.71647 17.8193C8.71647 18.2478 8.96142 18.6437 9.35898 18.8581C9.75655 19.0722 10.2465 19.0722 10.644 18.8581C11.0416 18.6437 11.2865 18.2478 11.2865 17.8193V14.4464C11.2865 14.0181 11.0416 13.6222 10.644 13.4079C10.2464 13.1938 9.75651 13.1938 9.35898 13.4079C8.96141 13.6223 8.71647 14.0181 8.71647 14.4464V17.8193ZM5.78308 8.11451L14.2168 8.11472V6.35171C14.176 4.97167 13.3634 3.71246 12.0754 3.03322C10.7875 2.35415 9.21245 2.35415 7.92444 3.03322C6.63649 3.71251 5.82387 4.97167 5.78308 6.35171V8.11451Z",
    fill: "#A1A1A1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.6700005dd3fd780e86628a063273f416.svg";
export { ForwardRef as ReactComponent };